import { ScreenSpaceEventHandler, ScreenSpaceEventType, Viewer } from "cesium";
import { DialogGeneral } from "../utils/Dialog/dialog";
import { createUUID } from "../utils/utils";
import '../styles/extensionToolbar.css'
import { IconExtension } from "../icon";
// import { DataPropeties } from "./dataProperties";
import { ToolTipButton } from "./toolTip/toolTipBtn";
import { DataPropeties } from "./newDataProperties";

export interface IOptionExtension {
    headerText?: string,
    htmlElement?: HTMLElement
    width?: string,
    height?: string,
    minimizeDialog?: boolean,
    isModal?: boolean,
    minHeight?: number
    minWidth?: number,
    top?: string,
    left?: string,
    bottom?: string,
    right?: string,
    zIndex?: number,
    enableResize?: boolean,
    allowDragging?: boolean,
    firstLoad?: boolean,
    isShow?: boolean,
    button?: IOptionUIButton
}

export interface IOptionUIButton {
    htmlButton?: HTMLElement | string,
    nameGroupBtn?: string,
    toolTip?: {
        anotation: string,
        duration: number
    }

}


export class ExtentionToolBar {
    private _viewer: Viewer
    private _containerId: string;
    handleMouse: ScreenSpaceEventHandler | undefined
    private _callback: (data: any) => void; // Callback từ Next.js
    modal: any
    IdGenneral = createUUID();//Tạo ID ngẫu nhiên khi khởi tạ
    private _dialog: DialogGeneral | undefined;
    private onClosedCallback: ((status: boolean) => void) | undefined;
    private _optionExtension: IOptionExtension
    private _dataProperties: DataPropeties | undefined
    constructor(containerId: string, viewer: Viewer, callback: (data: any) => void, option: IOptionExtension, dataProperties?: DataPropeties) {
        this._viewer = viewer;
        this._containerId = containerId
        this._callback = callback;
        this._optionExtension = {
            headerText: option.headerText ?? "",
            htmlElement: option.htmlElement ?? document.createElement('div'),
            width: option.width ?? "300px",
            height: option.height ?? "300px",
            minimizeDialog: option.minimizeDialog ?? true,
            isModal: option.isModal ?? false,
            minHeight: option.minHeight ?? 200,
            minWidth: option.minWidth ?? 200,
            top: option.top ?? '0',
            left: option.left ?? '0',
            bottom: option.bottom ?? 'auto',
            right: option.right ?? 'auto',
            zIndex: option.zIndex ?? 100,
            enableResize: option.enableResize ?? true,
            allowDragging: option.allowDragging ?? true,
            firstLoad: option.firstLoad ?? false,
            isShow: option.isShow ?? true,
            button: option.button ?? undefined
        }
        this._dataProperties = dataProperties
        this._createBtn()
        this._handleCreateCLick()

    }

    // Getter: Lấy giá trị của dialog
    get dialog(): DialogGeneral | undefined {
        return this._dialog;
    }
    triggerChange = (data: any) => {
        this._callback(data); // Gọi callback khi có thay đổi
    };

    // Gán callback từ lớp cha
    setClosedCallback(callback: (status: boolean) => void): void {
        this.onClosedCallback = callback;
    }
    // Gọi callback để thông báo thay đổi trạng thái
    notifyCallBack(status: boolean): void {
        if (this.onClosedCallback) {
            this.onClosedCallback(status); // Thông báo cho lớp cha
            if (!status) {
                this._btnEx?.classList.remove('active')
                this._isActived = false
                // this.removeAllClickEvents();
            }
        } else {
            console.error("State change callback is not set.");
        }
    }


    createModalDataElement = () => {
        this._dialog = new DialogGeneral(
            this._containerId,
            this.handleCloseModal
        );


        this._dialog.innerHeader = this._optionExtension.headerText
        this._dialog.widthModal = this._optionExtension.width!
        this._dialog.heightModal = this._optionExtension.height!
        this._dialog.minimizeDialog = this._optionExtension.minimizeDialog!
        this._dialog.isModal = this._optionExtension.isModal!
        this._dialog.minHeightModal = this._optionExtension.minHeight!
        this._dialog.minWidthModal = this._optionExtension.minWidth!
        this._dialog.topModal = this._optionExtension.top!
        this._dialog.leftModal = this._optionExtension.left!
        this._dialog.bottomModal = this._optionExtension.bottom!
        this._dialog.rightModal = this._optionExtension.right!
        this._dialog.zIndex = this._optionExtension.zIndex!
        this._dialog.enableResize = this._optionExtension.enableResize!
        this._dialog.allowDragging = this._optionExtension.allowDragging!
        this._dialog.firstLoad = this._optionExtension.firstLoad!


        this._dialog.innerBody = this.renderBodyDialog();

        this._dialog.createDialog();
    }

    private handleCloseModal = (status: boolean) => {
        if (!status) {
            this.notifyCallBack(status)

        }
    }


    //#region renderBodyDialog
    private _containerDiv: HTMLDivElement | undefined

    renderBodyDialog = () => {
        if (this._containerDiv) {
            this.clearContainer()
        } else {
            this._containerDiv = document.createElement('div')
            this._containerDiv.className = 'extension-body-dialog';
        }

        this._containerDiv.appendChild(this._optionExtension.htmlElement!)

        return this._containerDiv
    }

    private clearContainer = () => {
        if (this._containerDiv) {
            while (this._containerDiv.firstChild) {
                this._containerDiv.removeChild(this._containerDiv.firstChild);
            }
        }
    }

    private _btnEx: HTMLElement | undefined
    //#region Create Btn
    private _createBtn = () => {
        const containerId = document.querySelector(`#${this._containerId}`)
        const dpuToolBar = containerId?.querySelector('.custom-toolbar-dpu')

        let btnGroup

        if (this._optionExtension.button?.nameGroupBtn) {
            btnGroup = dpuToolBar?.querySelector(`#${this._optionExtension.button?.nameGroupBtn}`)
            if (!btnGroup) {
                btnGroup = document.createElement('div')
                btnGroup.id = this._optionExtension.button?.nameGroupBtn
            }
        } else {
            btnGroup = dpuToolBar?.querySelector(`#group-extension-${this._containerId}`)
            if (!btnGroup) {
                btnGroup = document.createElement('div')
                btnGroup.id = `group-extension-${this._containerId}`
            }

        }

        btnGroup.className = 'container-tool-cesium'
        this._btnEx = document.createElement('div')
        this._btnEx.id = `extension-${this.IdGenneral}`


        this._btnEx.className = 'btn-tool-cesium'
        const htmlBtn = this._optionExtension.button?.htmlButton
        if (htmlBtn) {
            if (typeof htmlBtn === 'string') {
                this._btnEx.innerHTML = htmlBtn
            } else {
                this._btnEx.appendChild(htmlBtn)
            }
        } else {
            this._btnEx.innerHTML = `${IconExtension()}`

        }

        btnGroup.appendChild(this._btnEx)
        dpuToolBar?.appendChild(btnGroup)

        const toolTip = this._optionExtension.button?.toolTip
        if (toolTip) {
            new ToolTipButton({
                containerViewId: this._containerId,
                htmlElement: this._btnEx,
                delayShow: toolTip.duration,
                toolTip: toolTip.anotation
            })
        }
        this._btnEx.addEventListener('click', this.handleActiveBtn)

    }

    //#region _handleActiveBtn

    private _isActived = false
    // isActived = (active: boolean) => {
    //     this._isActived = !active
    //     this.handleActiveBtn()
    //     return this._isActived
    // }



    handleActiveBtn = () => {
        this._isActived = !this._isActived
        if (this._isActived) {
            this._handleActionDialog(true)
            this._btnEx?.classList.add('active')
        } else {
            this._handleActionDialog(false)
            this._btnEx?.classList.remove('active')

        }
    }

    //#region _handleActionDialog
    private _isCreateDialog = false
    private _handleActionDialog = (open: boolean) => {
        if (!this._isCreateDialog && this._optionExtension.isShow) {
            this.createModalDataElement()
            this.dialog?.showModal(true)
            this._isCreateDialog = true //Khởi tạo dialog

        } else {
            if (open) {
                this.dialog?.showModal(true)
                this.triggerChange({
                    action: `Button Active`,
                    status: true
                })
            } else {
                this.dialog?.showModal(false)
                this.triggerChange({
                    action: `Button Active`,
                    status: false
                })
            }
        }

    }

    //#region _handleActionDialog
    private _handleCreateCLick = () => {
        if (!this.handleMouse) {
            this.handleMouse = new ScreenSpaceEventHandler(this._viewer.canvas)
        }
        this.handleMouse.setInputAction((movement: ScreenSpaceEventHandler.PositionedEvent) => {
            if (this._dataProperties) {
                const listObj = this._dataProperties.objs
                this.triggerChange({
                    action: 'Mouse Clicked',
                    status: undefined,
                    properties: listObj
                })
            }
        }, ScreenSpaceEventType.LEFT_CLICK);

    }


}


